import axiosInstance from "./axiosInstance";

const submitLogoToForeignPartner = (userId, images) =>
    axiosInstance.post(`/users/${userId}/google_drive_images`, images, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Key-Inflection": "camel",
        },
    });

export {
    submitLogoToForeignPartner,
}